 /**
  * Example usage below
  * <s-countdown data-targetdate="{{ targetDate }} {{ targetTime }}">
    <p js-stage-default>
    </p>
    <p js-stage-complete>
    </p>
    <p js-stage-default>
        <span class="" js-countdown-days>00</span> DAYS :
        <span class="" js-countdown-hours>00</span> HR :
        <span class="" js-countdown-minutes>00</span> MIN :
        <span class="" js-countdown-seconds>00</span> SEC
    </p>
    <p js-stage-complete>
    </p>
  *</s-countdown> 
**/

class Countdown extends HTMLElement {
    constructor() {
      super();
  
      this._selectors = {
        countdown: {
            days: '[js-countdown-days]',
            hours: '[js-countdown-hours]',
            minutes: '[js-countdown-minutes]',
            seconds: '[js-countdown-seconds]'
        },
        jsonData: '[js-countdown-data]',
        stages: {
            default: '[js-stage-default]',
            complete: '[js-stage-complete]'
        }
      }
      
      this.stages = {
        default: this.querySelectorAll(this._selectors.stages.default),
        complete: this.querySelectorAll(this._selectors.stages.complete)
      }

      this.countdown = {
        days: this.querySelector(this._selectors.countdown.days),
        hours: this.querySelector(this._selectors.countdown.hours),
        minutes: this.querySelector(this._selectors.countdown.minutes),
        seconds: this.querySelector(this._selectors.countdown.seconds)
      }

    }
  
    connectedCallback() {
        const targetDate = this.getAttribute('data-targetdate')
        this._initCountdown(targetDate)
        this._displayCountdown()
    }

    _setStage(stage){
        if(stage == 'complete'){
            this.stages.complete.forEach((item) => item.classList.remove('hidden'))
            this.stages.default.forEach((item) => item.classList.add('hidden'))
        } else if(stage == 'default') {
            this.stages.default.forEach((item) => item.classList.remove('hidden'))
            this.stages.complete.forEach((item) => item.classList.add('hidden'))
        }
    }

    _displayCountdown(){
        this.classList.remove('opacity-0')
        this.classList.add('opacity-100')
    }

    _initCountdown(targetDate){
        const deadlinePT = new Date(targetDate)
        const deadline = new Date(deadlinePT).getTime()
    
        const formatTime = (time) => {
            return String(time).padStart(2, '0')
        }
    
        const interval = setInterval(() => {
            const nowPT = new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
            let now = new Date(nowPT).getTime()
            let t = deadline - now
        
            if (t <= 0) {
                this.countdown.days.innerHTML = formatTime(0)
                this.countdown.hours.innerHTML = formatTime(0)
                this.countdown.minutes.innerHTML = formatTime(0)
                this.countdown.seconds.innerHTML = formatTime(0)
                clearInterval(interval)
                if(this.stages.complete) this._setStage('complete')
                return
            }
    
            this.countdown.days.innerHTML = formatTime(Math.floor(t / (1000 * 60 * 60 * 24)))
            this.countdown.hours.innerHTML = formatTime(Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
            this.countdown.minutes.innerHTML = formatTime(Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)))
            this.countdown.seconds.innerHTML = formatTime(Math.floor((t % (1000 * 60)) / 1000))
            this._setStage('default')
            
        }, 1000)

    }

}

customElements.define('s-countdown', Countdown);